import _ from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import localforage from 'localforage';
// TODO: in case of localStorage fallback there must be restoreState method implemented

const vuexLocal = new VuexPersistence({
  storage: localforage,
  key: 'swz',
})

// modules
import security from './security';
import order from './order';
import product from './product';

Vue.use(Vuex);

export default new Vuex.Store({
  state() {
    return state;
  },
  mutations,
  getters,
  actions,
  modules: {
    security,
    order,
    product
  },
  plugins: [vuexLocal.plugin]
});